// extracted by mini-css-extract-plugin
export default {"container":"ZeroToFive--container--91150b","title":"ZeroToFive--title--9225f9","description":"ZeroToFive--description--2700a1","actions":"ZeroToFive--actions--1ac393"};